import * as i0 from '@angular/core';
import { Directive, Input, EventEmitter, Component, ContentChildren, Output, ViewChild, NgModule } from '@angular/core';
import { convertToRem, convertToRelativePx } from '@appkit4/angular-components/utils';
import * as i1 from '@appkit4/angular-components/dropdown';
import { DropdownService } from '@appkit4/angular-components/dropdown';
import * as i2 from '@appkit4/angular-components/shared';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import { DropdownListItemModule } from '@appkit4/angular-components/dropdown-list-item';
import { NgClickOutsideDirective } from 'ng-click-outside2';

class CustomizeTemplate {
    constructor(template) {
        this.template = template;
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CustomizeTemplate, deps: [{ token: i0.TemplateRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.11", type: CustomizeTemplate, selector: "[ngTemplate]", inputs: { type: "type", name: ["ngTemplate", "name"] }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: CustomizeTemplate, decorators: [{
            type: Directive,
            args: [{
                    selector: "[ngTemplate]",
                    host: {},
                }]
        }], ctorParameters: () => [{ type: i0.TemplateRef }], propDecorators: { type: [{
                type: Input
            }], name: [{
                type: Input,
                args: ["ngTemplate"]
            }] } });
class AvatarComponent {
    constructor(el, render, cd, dropdownService, focusIndicatorService) {
        this.el = el;
        this.render = render;
        this.cd = cd;
        this.dropdownService = dropdownService;
        this.focusIndicatorService = focusIndicatorService;
        this.name = "";
        this.diameter = "";
        this.backgroundColor = "";
        this.fontColor = "";
        this.borderColor = "";
        this.borderWidth = "4";
        this.marginLeft = "0";
        this.zIndex = "0";
        this.imageSrc = "";
        this.iconClass = "";
        this.style = "";
        this.styleClass = "";
        this.role = "";
        this.disabled = false;
        this.withMask = false;
        this.tabindex = 0;
        this.ariaLabel = "";
        this.withDropdown = false;
        this.compact = false;
        this.alignDirection = "right";
        this.onClick = new EventEmitter();
        this.onFocus = new EventEmitter();
        this.onBlur = new EventEmitter();
        this.avatarTabindex = 0;
        this.avatarStyle = {};
        this.imageStyle = {};
        // maskStyle: string = '';
        this.isFocused = false;
        this.showDropdown = false;
        this.normalTempItem = {};
        this.avatarId = "";
        this.marginTopValue = "";
        this.curIndex = 0;
        this.preKey = "";
    }
    ngOnChanges(changes) {
        if (changes.disabled) {
            if (changes.disabled.currentValue)
                this.avatarTabindex = -1;
            else if (!changes.disabled.currentValue)
                this.avatarTabindex = this.tabindex;
        }
        if (changes.tabindex) {
            this.avatarTabindex = this.disabled
                ? -1
                : changes.tabindex.currentValue;
        }
        if (changes.backgroundColor ||
            changes.color ||
            changes.borderColor ||
            changes.borderWidth ||
            changes.diameter ||
            changes.fontColor ||
            changes.marginLeft ||
            changes.zIndex ||
            changes.withDropdown) {
            this.avatarStyle = {
                width: convertToRem(Number(this.diameter)),
                height: convertToRem(Number(this.diameter)),
                backgroundColor: this.backgroundColor,
                color: this.fontColor,
                borderColor: `${this.borderColor}`,
                borderWidth: this.borderWidth && convertToRem(Number(this.borderWidth)),
                marginLeft: this.marginLeft && convertToRem(Number(this.marginLeft)),
                zIndex: `${this.zIndex}`,
                position: "relative",
            };
            this.imageStyle = {
                width: convertToRem(Number(this.diameter)),
                height: convertToRem(Number(this.diameter)),
            };
            this.marginTopValue = convertToRem(Number(this.diameter) + convertToRelativePx(8));
            let avatarContainerBox = this.el.nativeElement.firstChild;
            if (avatarContainerBox)
                avatarContainerBox.style.setProperty("--marginTopValue", this.marginTopValue);
            // this.maskStyle = `width: ${parseInt(this.diameter) + 8}px; height: ${parseInt(this.diameter) + 8}px; backgroundColor: ${this.backgroundColor}`;
            if (this.imageSrc) {
                Object.assign(this.avatarStyle, { overflow: "hidden" });
                Object.assign(this.avatarStyle, { backgroundColor: "#ffffff" });
            }
            if (this.iconClass) {
                Object.assign(this.avatarStyle, {
                    backgroundColor: this.backgroundColor,
                });
            }
        }
        setTimeout(() => {
            this.dropdownListItem.toArray().forEach((o) => {
                o.onSelectItem.subscribe((event) => {
                    this.list.forEach((item) => {
                        item.checked = item.value === event.selected.value;
                    });
                    this.onSelectedChange(event);
                });
            });
        }, 300);
    }
    ngOnInit() {
        if (!this.avatarId) {
            this.avatarId = "avatar" + Math.round(Math.random() * 1000);
        }
        if (this.compact) {
            if (!this.diameter) {
                this.diameter = "32";
            }
        }
        else {
            if (!this.diameter) {
                this.diameter = "40";
            }
        }
        this.avatarStyle = {
            width: convertToRem(Number(this.diameter)),
            height: convertToRem(Number(this.diameter)),
            backgroundColor: this.backgroundColor,
            color: this.fontColor,
            borderColor: `${this.borderColor}`,
            borderWidth: this.borderWidth && convertToRem(Number(this.borderWidth)),
            marginLeft: this.marginLeft && convertToRem(Number(this.marginLeft)),
            zIndex: `${this.zIndex}`,
            position: "relative",
        };
        this.imageStyle = {
            width: convertToRem(Number(this.diameter)),
            height: convertToRem(Number(this.diameter)),
        };
        this.marginTopValue = convertToRem(Number(this.diameter) + convertToRelativePx(8));
        // this.maskStyle = `width: ${parseInt(this.diameter) + 8}px; height: ${parseInt(this.diameter) + 8}px; backgroundColor: ${this.backgroundColor}`;
        if (this.imageSrc) {
            Object.assign(this.avatarStyle, { overflow: "hidden" });
            Object.assign(this.avatarStyle, { backgroundColor: "#ffffff" });
        }
        if (this.iconClass) {
            Object.assign(this.avatarStyle, {
                backgroundColor: this.backgroundColor,
            });
        }
        if (this.disabled) {
            this.avatarTabindex = -1;
        }
        else {
            this.avatarTabindex = this.tabindex;
        }
        if (!this.ariaLabel) {
            this.ariaLabel = this.name || "";
        }
    }
    ngAfterViewInit() {
        if (this.style) {
            if (typeof this.style === "string") {
                this.el.nativeElement.querySelector(".ap-avatar").style.cssText += this.style;
            }
            else {
                Object.assign(this.avatarStyle, this.style);
            }
        }
        if (this.withDropdown) {
            let avatarContainerBox = this.el.nativeElement.firstChild;
            if (avatarContainerBox)
                avatarContainerBox.style.setProperty("--marginTopValue", this.marginTopValue);
        }
    }
    onFocusEvent(event) {
        if (this.disabled) {
            return;
        }
        this.isFocused = true;
        this.onFocus.emit(event);
    }
    onBlurEvent(event) {
        if (this.disabled) {
            return;
        }
        this.isFocused = false;
        this.onBlur.emit(event);
    }
    clickAvatar(event) {
        // if (event) event.stopPropagation();
        if (this.disabled)
            return;
        this.showDropdown ? this.hide() : this.show();
        // if (this.role === 'button' || this.role === 'link') {
        this.onClick.emit(event);
        // }
        this.dropdownService.normalDataRemoveKeyboard(this.list);
    }
    searchDropList(k, code) {
        if (code < 65 || code > 90)
            return;
        if (!this.showDropdown) {
            this.show(); // expend dropdown list when type a key
        }
        const focusedItem = this.list.filter((i) => i.label.toLowerCase().indexOf(k) === 0);
        if (focusedItem.length > 0) {
            if (this.preKey === "") {
                this.preKey = k;
            }
            else if (this.preKey === k) {
                this.curIndex++;
                if (this.curIndex === focusedItem.length) {
                    this.curIndex = 0; // loop focus item when type same key
                }
            }
            else {
                this.curIndex = 0;
                this.preKey = k;
            }
            this.normalTempItem = focusedItem[this.curIndex]; // focus on the first matched item
            if (this.normalTempItem.disabled) {
                return; // disabled item will not be focused
            }
            else {
                this.dropdownService.normalDataUpdateStatus(this.list, "label", this.normalTempItem);
            }
        }
    }
    onKeyDown(event) {
        if (this.disabled)
            return;
        let keyCode = event.keyCode;
        if (this.withDropdown) {
            switch (keyCode) {
                case 27: //esc
                    if (this.showDropdown) {
                        this.hide();
                    }
                    event.preventDefault();
                    break;
                case 40: //down;
                    this.downNext(this.normalTempItem);
                    event.preventDefault();
                    // event.stopPropagation();
                    break;
                case 38: // up
                    this.upNext(this.normalTempItem);
                    event.preventDefault();
                    // event.stopPropagation();
                    break;
                case 13: //enter
                case 32: //space
                    if (!this.showDropdown) {
                        this.show();
                        if (Object.keys(this.normalTempItem).length === 0) {
                            this.setSingleFocusedItem(0);
                        }
                        this.dropdownService.normalDataUpdateStatus(this.list, "label", this.normalTempItem);
                    }
                    else {
                        let selectTemp = this.dropdownListItem
                            .toArray()
                            .find((o) => o.item.focused === true);
                        if (selectTemp) {
                            selectTemp.onSelectItem.next({
                                originEvent: event,
                                selected: this.normalTempItem,
                                eventType: "keydown",
                            });
                        }
                    }
                    event.preventDefault();
                    break;
                case 9: //tab
                    if (this.showDropdown) {
                        this.hide();
                    }
                    break;
            }
            this.searchDropList(event.key.toLowerCase(), keyCode);
        }
        if ((keyCode === 13 &&
            (this.role === "button" || this.role === "link")) ||
            (keyCode === 32 && this.role === "button")) {
            event.preventDefault();
            this.onClick.emit();
        }
    }
    onSelectedChange(event) {
        this.hide();
        if (event.eventType && event.eventType === "click") {
            this.dropdownService.normalDataRemoveKeyboard(this.list);
            this.normalTempItem = event.selected;
        }
    }
    ngAfterContentInit() {
        if (this.templates.length) {
            this.templateMap = {};
        }
        this.templates.forEach((item) => {
            this.templateMap[item.name] = item.template;
        });
    }
    downNext(nextItem) {
        this.normalTempItem = nextItem;
        let selectedItemIndex = this.dropdownService.findOptionIndex(this.normalTempItem, this.list, "label");
        if (selectedItemIndex !== -1) {
            let nextItemIndex = selectedItemIndex + 1;
            if (nextItemIndex < this.list.length) {
                this.normalTempItem = this.list[nextItemIndex];
            }
            else {
                this.normalTempItem = this.list[0];
            }
        }
        else {
            this.normalTempItem = this.list[0];
        }
        if (this.normalTempItem.disabled) {
            this.downNext(this.normalTempItem);
        }
        else {
            this.dropdownService.normalDataUpdateStatus(this.list, "label", this.normalTempItem);
        }
    }
    upNext(nextItem) {
        this.normalTempItem = nextItem;
        let selectedItemIndex = this.dropdownService.findOptionIndex(this.normalTempItem, this.list, "label");
        if (selectedItemIndex !== -1) {
            let preItemIndex = selectedItemIndex - 1;
            if (preItemIndex >= 0) {
                this.normalTempItem = this.list[preItemIndex];
            }
            else {
                let length = this.list.length - 1;
                this.normalTempItem = this.list[length];
            }
        }
        else {
            let length = this.list.length - 1;
            this.normalTempItem = this.list[length];
        }
        if (this.normalTempItem.disabled) {
            this.upNext(this.normalTempItem);
        }
        else {
            this.dropdownService.normalDataUpdateStatus(this.list, "label", this.normalTempItem);
        }
    }
    setSingleFocusedItem(index) {
        let disabledStatus = this.list[index].disabled;
        if (!disabledStatus) {
            this.normalTempItem = this.list[index];
        }
        else {
            index = index + 1;
            this.setSingleFocusedItem(index);
        }
    }
    ngOnDestroy() {
        this.unbindDocumentListener();
    }
    show() {
        this.showDropdown = true;
        this.bindDocumentListener();
    }
    hide() {
        this.showDropdown = false;
        this.unbindDocumentListener();
    }
    bindDocumentListener() {
        if (!this.documentClickListener) {
            this.documentClickListener = this.render.listen(window, "click", (event) => {
                if (event.target.shadowRoot) {
                    const path = event.composedPath();
                    let self = false;
                    for (let i = 0; i < 5; i++) {
                        if (path[i] &&
                            path[i].id &&
                            path[i].id.indexOf(this.avatarId) !== -1) {
                            self = true;
                            break;
                        }
                    }
                    if (self) {
                        return;
                    }
                    else {
                        this.hide();
                        this.cd.detectChanges();
                    }
                }
                else {
                    if (this.avatarWrapper.nativeElement.contains(event.target)) {
                        return;
                    }
                    else {
                        this.hide();
                        this.cd.detectChanges();
                    }
                }
            });
        }
    }
    unbindDocumentListener() {
        if (this.documentClickListener) {
            this.documentClickListener();
            this.documentClickListener = null;
        }
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AvatarComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }, { token: i0.ChangeDetectorRef }, { token: i1.DropdownService }, { token: i2.FocusIndicatorService }], target: i0.ɵɵFactoryTarget.Component }); }
    static { this.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "17.3.11", type: AvatarComponent, selector: "ap-avatar", inputs: { name: "name", diameter: "diameter", backgroundColor: "backgroundColor", fontColor: "fontColor", borderColor: "borderColor", borderWidth: "borderWidth", marginLeft: "marginLeft", zIndex: "zIndex", imageSrc: "imageSrc", iconClass: "iconClass", style: "style", styleClass: "styleClass", role: "role", disabled: "disabled", withMask: "withMask", tabindex: "tabindex", ariaLabel: "ariaLabel", withDropdown: "withDropdown", list: "list", compact: "compact", alignDirection: "alignDirection" }, outputs: { onClick: "onClick", onFocus: "onFocus", onBlur: "onBlur" }, queries: [{ propertyName: "dropdownListItem", predicate: ["dropdownListItem"] }, { propertyName: "templates", predicate: CustomizeTemplate }], viewQueries: [{ propertyName: "avatarWrapper", first: true, predicate: ["avatarWrapper"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"ap-avatar-container\" [attr.id]=\"avatarId\" #avatarWrapper>\n  <div class=\"ap-avatar {{styleClass}}\" (click)=\"clickAvatar($event)\" (keydown)=\"onKeyDown($event)\"\n    [class.disabled]=\"disabled\" [class.mask]=\"withMask\" [ngStyle]=\"avatarStyle\" [attr.role]=\"role\"\n    [attr.aria-label]=\"ariaLabel\" (focus)=\"onFocusEvent($event)\" (blur)=\"onBlurEvent($event)\"\n    [tabindex]=\"avatarTabindex\">\n    <span class=\"ap-avatar-text\" [ngClass]=\"compact ? 'compact': ''\"\n      *ngIf=\"!imageSrc && !iconClass && name\">{{name}}</span>\n    <img [ngStyle]=\"imageStyle\" *ngIf=\"imageSrc&&!iconClass\" [src]=\"imageSrc\" alt=\"\">\n    <span class=\"Appkit4-icon\" [class]=\"iconClass\" *ngIf=\"iconClass&&!imageSrc\"></span>\n    <ng-content></ng-content>\n    <!-- <div [style]=\"isFocused ? maskStyle : ''\" [class.back-mask]=\"isFocused\"></div> -->\n  </div>\n  <ng-container *ngIf=\"withDropdown\">\n    <div class=\"avatar-list-box\" [attr.role]=\"'listbox'\" [attr.aria-hidden]=\"withDropdown ? false : null\"\n      [attr.aria-labelle]=\"'avatar dropdown list'\" [class.show]=\"showDropdown\"\n      [class.alignLeft]=\"alignDirection === 'left'\" [class.alignRight]=\"alignDirection === 'right'\">\n      <div *ngIf=\"templateMap && templateMap['dropdownTemp']\">\n        <ng-container *ngTemplateOutlet=\"templateMap['dropdownTemp']\"></ng-container>\n      </div>\n    </div>\n  </ng-container>\n</div>", styles: [".mask{-webkit-mask-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"UTF-8\"?>%0A<svg width=\"36px\" height=\"40px\" viewBox=\"0 0 36 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">%0A    <title>Mask</title>%0A    <defs>%0A        <path d=\"M0.001,7.426 C2.253,11.083 3.554,15.39 3.554,20 L3.554,20 C3.554,24.61 2.253,28.917 0,32.574 L0,32.574 C3.667,37.104 9.272,40 15.554,40 L15.554,40 C26.599,40 35.553,31.046 35.553,20 L35.553,20 C35.553,8.955 26.599,0 15.554,0 L15.554,0 C9.272,0 3.667,2.896 0.001,7.426 L0.001,7.426 Z\" id=\"path-1\"></path>%0A    </defs>%0A    <g id=\"Avatar\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">%0A        <mask id=\"mask-2\" fill=\"white\">%0A            <use xlink:href=\"%23path-1\"></use>%0A        </mask>%0A        <use id=\"Mask\" fill=\"%23111111\" xlink:href=\"%23path-1\"></use>%0A    </g>%0A</svg>');mask-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"UTF-8\"?>%0A<svg width=\"36px\" height=\"40px\" viewBox=\"0 0 36 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">%0A    <title>Mask</title>%0A    <defs>%0A        <path d=\"M0.001,7.426 C2.253,11.083 3.554,15.39 3.554,20 L3.554,20 C3.554,24.61 2.253,28.917 0,32.574 L0,32.574 C3.667,37.104 9.272,40 15.554,40 L15.554,40 C26.599,40 35.553,31.046 35.553,20 L35.553,20 C35.553,8.955 26.599,0 15.554,0 L15.554,0 C9.272,0 3.667,2.896 0.001,7.426 L0.001,7.426 Z\" id=\"path-1\"></path>%0A    </defs>%0A    <g id=\"Avatar\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">%0A        <mask id=\"mask-2\" fill=\"white\">%0A            <use xlink:href=\"%23path-1\"></use>%0A        </mask>%0A        <use id=\"Mask\" fill=\"%23111111\" xlink:href=\"%23path-1\"></use>%0A    </g>%0A</svg>');-webkit-mask-position:right;mask-position:right;-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.ap-avatar{border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:var(--color-background-primary);color:var(--color-text-secondary);border-color:var(--color-text-primary);border-style:solid;font-weight:var(--font-weight-2);padding:var(--spacing-3);position:relative;-webkit-user-select:none;user-select:none;cursor:pointer}.ap-avatar:not(.mask){color:var(--color-text-tertiary)}.ap-avatar.disabled{cursor:default}.ap-avatar:not(.disabled):focus{outline:none;box-shadow:0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}.ap-avatar-text{display:flex;align-items:center;justify-content:center;width:100%;height:100%}.ap-avatar-text.compact{font:var(--typography-body-s);font-weight:var(--font-weight-1)}.ap-avatar .back-mask{position:absolute;top:-.25rem;left:-.25rem;background-color:var(--color-background-primary);border-radius:50%;opacity:var(--opacity-3)}.ap-avatar-container{position:relative}.avatar-list-box{position:absolute;display:block;top:0!important;margin-top:var(--marginTopValue);padding:var(--spacing-3);width:17.125rem;right:0;border-radius:var(--border-radius-3);transition:all .3s;z-index:99;background-color:var(--color-background-container);color:var(--color-text-heading);box-shadow:var(--box-shadow-3)!important;font-weight:400}.avatar-list-box:not(.show){visibility:hidden;transform:translateY(var(--spacing-4));opacity:0}.avatar-list-box.alignRight{left:auto}.avatar-list-box.alignLeft{left:0}::ng-deep [data-keyboard-focus=true] .ap-avatar:not(.disabled):focus{box-shadow:none!important;outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}\n"], dependencies: [{ kind: "directive", type: i3.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i3.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i3.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: i3.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AvatarComponent, decorators: [{
            type: Component,
            args: [{ selector: "ap-avatar", template: "<div class=\"ap-avatar-container\" [attr.id]=\"avatarId\" #avatarWrapper>\n  <div class=\"ap-avatar {{styleClass}}\" (click)=\"clickAvatar($event)\" (keydown)=\"onKeyDown($event)\"\n    [class.disabled]=\"disabled\" [class.mask]=\"withMask\" [ngStyle]=\"avatarStyle\" [attr.role]=\"role\"\n    [attr.aria-label]=\"ariaLabel\" (focus)=\"onFocusEvent($event)\" (blur)=\"onBlurEvent($event)\"\n    [tabindex]=\"avatarTabindex\">\n    <span class=\"ap-avatar-text\" [ngClass]=\"compact ? 'compact': ''\"\n      *ngIf=\"!imageSrc && !iconClass && name\">{{name}}</span>\n    <img [ngStyle]=\"imageStyle\" *ngIf=\"imageSrc&&!iconClass\" [src]=\"imageSrc\" alt=\"\">\n    <span class=\"Appkit4-icon\" [class]=\"iconClass\" *ngIf=\"iconClass&&!imageSrc\"></span>\n    <ng-content></ng-content>\n    <!-- <div [style]=\"isFocused ? maskStyle : ''\" [class.back-mask]=\"isFocused\"></div> -->\n  </div>\n  <ng-container *ngIf=\"withDropdown\">\n    <div class=\"avatar-list-box\" [attr.role]=\"'listbox'\" [attr.aria-hidden]=\"withDropdown ? false : null\"\n      [attr.aria-labelle]=\"'avatar dropdown list'\" [class.show]=\"showDropdown\"\n      [class.alignLeft]=\"alignDirection === 'left'\" [class.alignRight]=\"alignDirection === 'right'\">\n      <div *ngIf=\"templateMap && templateMap['dropdownTemp']\">\n        <ng-container *ngTemplateOutlet=\"templateMap['dropdownTemp']\"></ng-container>\n      </div>\n    </div>\n  </ng-container>\n</div>", styles: [".mask{-webkit-mask-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"UTF-8\"?>%0A<svg width=\"36px\" height=\"40px\" viewBox=\"0 0 36 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">%0A    <title>Mask</title>%0A    <defs>%0A        <path d=\"M0.001,7.426 C2.253,11.083 3.554,15.39 3.554,20 L3.554,20 C3.554,24.61 2.253,28.917 0,32.574 L0,32.574 C3.667,37.104 9.272,40 15.554,40 L15.554,40 C26.599,40 35.553,31.046 35.553,20 L35.553,20 C35.553,8.955 26.599,0 15.554,0 L15.554,0 C9.272,0 3.667,2.896 0.001,7.426 L0.001,7.426 Z\" id=\"path-1\"></path>%0A    </defs>%0A    <g id=\"Avatar\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">%0A        <mask id=\"mask-2\" fill=\"white\">%0A            <use xlink:href=\"%23path-1\"></use>%0A        </mask>%0A        <use id=\"Mask\" fill=\"%23111111\" xlink:href=\"%23path-1\"></use>%0A    </g>%0A</svg>');mask-image:url('data:image/svg+xml,<?xml version=\"1.0\" encoding=\"UTF-8\"?>%0A<svg width=\"36px\" height=\"40px\" viewBox=\"0 0 36 40\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\">%0A    <title>Mask</title>%0A    <defs>%0A        <path d=\"M0.001,7.426 C2.253,11.083 3.554,15.39 3.554,20 L3.554,20 C3.554,24.61 2.253,28.917 0,32.574 L0,32.574 C3.667,37.104 9.272,40 15.554,40 L15.554,40 C26.599,40 35.553,31.046 35.553,20 L35.553,20 C35.553,8.955 26.599,0 15.554,0 L15.554,0 C9.272,0 3.667,2.896 0.001,7.426 L0.001,7.426 Z\" id=\"path-1\"></path>%0A    </defs>%0A    <g id=\"Avatar\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">%0A        <mask id=\"mask-2\" fill=\"white\">%0A            <use xlink:href=\"%23path-1\"></use>%0A        </mask>%0A        <use id=\"Mask\" fill=\"%23111111\" xlink:href=\"%23path-1\"></use>%0A    </g>%0A</svg>');-webkit-mask-position:right;mask-position:right;-webkit-mask-size:contain;mask-size:contain;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}.ap-avatar{border-radius:50%;display:flex;align-items:center;justify-content:center;background-color:var(--color-background-primary);color:var(--color-text-secondary);border-color:var(--color-text-primary);border-style:solid;font-weight:var(--font-weight-2);padding:var(--spacing-3);position:relative;-webkit-user-select:none;user-select:none;cursor:pointer}.ap-avatar:not(.mask){color:var(--color-text-tertiary)}.ap-avatar.disabled{cursor:default}.ap-avatar:not(.disabled):focus{outline:none;box-shadow:0 0 0 .25rem rgba(var(--color-background-primary-rgb),var(--opacity-3))}.ap-avatar-text{display:flex;align-items:center;justify-content:center;width:100%;height:100%}.ap-avatar-text.compact{font:var(--typography-body-s);font-weight:var(--font-weight-1)}.ap-avatar .back-mask{position:absolute;top:-.25rem;left:-.25rem;background-color:var(--color-background-primary);border-radius:50%;opacity:var(--opacity-3)}.ap-avatar-container{position:relative}.avatar-list-box{position:absolute;display:block;top:0!important;margin-top:var(--marginTopValue);padding:var(--spacing-3);width:17.125rem;right:0;border-radius:var(--border-radius-3);transition:all .3s;z-index:99;background-color:var(--color-background-container);color:var(--color-text-heading);box-shadow:var(--box-shadow-3)!important;font-weight:400}.avatar-list-box:not(.show){visibility:hidden;transform:translateY(var(--spacing-4));opacity:0}.avatar-list-box.alignRight{left:auto}.avatar-list-box.alignLeft{left:0}::ng-deep [data-keyboard-focus=true] .ap-avatar:not(.disabled):focus{box-shadow:none!important;outline:auto .125rem Highlight;outline:auto .3125rem -webkit-focus-ring-color;outline-offset:var(--spacing-1)}\n"] }]
        }], ctorParameters: () => [{ type: i0.ElementRef }, { type: i0.Renderer2 }, { type: i0.ChangeDetectorRef }, { type: i1.DropdownService }, { type: i2.FocusIndicatorService }], propDecorators: { name: [{
                type: Input
            }], diameter: [{
                type: Input
            }], backgroundColor: [{
                type: Input
            }], fontColor: [{
                type: Input
            }], borderColor: [{
                type: Input
            }], borderWidth: [{
                type: Input
            }], marginLeft: [{
                type: Input
            }], zIndex: [{
                type: Input
            }], imageSrc: [{
                type: Input
            }], iconClass: [{
                type: Input
            }], style: [{
                type: Input
            }], styleClass: [{
                type: Input
            }], role: [{
                type: Input
            }], disabled: [{
                type: Input
            }], withMask: [{
                type: Input
            }], tabindex: [{
                type: Input
            }], ariaLabel: [{
                type: Input
            }], withDropdown: [{
                type: Input
            }], list: [{
                type: Input
            }], compact: [{
                type: Input
            }], alignDirection: [{
                type: Input
            }], dropdownListItem: [{
                type: ContentChildren,
                args: ["dropdownListItem"]
            }], onClick: [{
                type: Output
            }], onFocus: [{
                type: Output
            }], onBlur: [{
                type: Output
            }], templates: [{
                type: ContentChildren,
                args: [CustomizeTemplate]
            }], avatarWrapper: [{
                type: ViewChild,
                args: ["avatarWrapper"]
            }] } });

class AvatarModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AvatarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.11", ngImport: i0, type: AvatarModule, declarations: [AvatarComponent, CustomizeTemplate], imports: [CommonModule,
            DropdownListItemModule,
            NgClickOutsideDirective], exports: [AvatarComponent, DropdownListItemModule, CustomizeTemplate] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AvatarModule, providers: [DropdownService], imports: [CommonModule,
            DropdownListItemModule, DropdownListItemModule] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.11", ngImport: i0, type: AvatarModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        DropdownListItemModule,
                        NgClickOutsideDirective
                    ],
                    declarations: [AvatarComponent, CustomizeTemplate],
                    exports: [AvatarComponent, DropdownListItemModule, CustomizeTemplate],
                    providers: [DropdownService]
                }]
        }] });

/**
 * Generated bundle index. Do not edit.
 */

export { AvatarComponent, AvatarModule, CustomizeTemplate };
